module.exports = __webpack_public_path__ + "static/media/icon-error.dce46f5b.svg";